
import Vue from "vue";
import AppAdminSelect from "../components/AdminSelect.vue";
import AppAdminCheckboxesSelect from "../components/AdminCheckboxesSelect.vue";
import AppSelectDepartment from "../components/DepartmentSelect.vue";
import AppTicketMessage from "@/components/ticket/TicketMessage.vue";
import AppPeppolActivationModal from "@/components/dossier/DossierPeppolEndpointCreateModal.vue";
import AppTicketStatusSelect from "@/components/ticket/TicketStatusSelect.vue";
import {Admin} from "@/models/admin";
import {Ticket} from "@/models/ticket";
import {TicketMessage} from "@/models/ticket-message";
import {CRM} from "@/models/crm";
import {TicketService} from "@/services/ticket-service";
import {CompanyService} from "@/services/company-service";
import {setTitle, resetTitle} from "@/utils/title";
import AppTicketSelectPriority from "@/components/ticket/TicketSelectPriority.vue";
import {Company} from "@/models/company";
import {CompanyVars} from "@/models/company-vars";
import AppTicketPinButton from "@/components/ticket/TicketPinButton.vue";
import AppTicketBookmarkButton from "@/components/ticket/TicketBookmarkButton.vue";
import AppTicketMessageActions from "@/components/ticket/TicketMessageActions.vue";
import AppTicketReplyTemplateButton from "@/components/ticket/TicketReplyTemplateButton.vue";
import AppTicketCrm from "@/components/ticket/TicketCrm.vue";
import {TicketReplyTemplate} from "@/models/ticket-reply-template";
import {AdminsService} from "@/services/admins-service";
import AppTicketNextAndPreviousButtons from "@/components/ticket/TicketNextAndPreviousButtons.vue";
import AppTicketPasteAttachmentPreview from "@/components/ticket/TicketPasteAttacmentPreview.vue";
import {getTicketStatusName} from "@/utils/ticket-status";
import AppLoginAsUserButton from "@/components/LoginAsUserButton.vue";
import { specialLink } from "@/utils/special-link";
import { autoLink } from "@/utils/auto-link";
import { CompanyDossierService } from "@/services";
import AppTicketEditSubjectModal from "@/components/ticket/TicketEditSubjectModal.vue";

export default Vue.extend({
	data() {
		return {
			ticket: {} as any as Ticket,
			ready: false,
			content: "",
			attentions: [] as Admin[],
			isPrivate: true,
			isPublic: false,
			dragLevel: 0,
			attentionModal: false,
			showOptions: true,
			notifyUser: true,
			updatingMessageId: 0,
			showModuleModal: false,
			company: new Company(),
			showTimeSheduledModal: false,
			date: new Date(),
			time: new Date(),
			textareaExpanded: false,
			editAttentions: 0,
			addAutoMessage: false,
			toggleCrm: false,
			onPasteToSendFiles: [] as File[],
			showInitialMessage: false,
			showPeppolActivationModal: false,
			editSubjectModal: false,
			companyVars: new CompanyVars()
		};
	},
	computed: {

		modulesAsString():string{
			if (this.company.modulesAsString) return this.company.modulesAsString;
			if (this.ticket.company) return this.company.modulesAsString;
			return "";
		},
		/**
		 * Give a visual warning to the Support team
		 * This could be due to inactive account, SP exepiration, ...
		 * This is still to be determined!
		 */
		isExternal(): boolean{
			return !this.$route.path.includes("tickets");
		},
		blocked(): boolean{
			return this.company.Blocked;
		},
		dossierName(): string{
			if(this.company.dossiers){
				let c = this.company.dossiers.filter(d => d.id == this.ticket.dossierId);
				if (c[0]) {
					return c[0].name;
				}
			}

			return this.ticket.dossierName;
		},
		showPeppolActivateButton(){

			if(this.company.dossiers){
				let c = this.company.dossiers.filter(d => d.id == this.ticket.dossierId);
				if(c[0] && c[0].peppolIds.length > 0){
					return false;
				}
				if(c[0] && c[0].peppolRegistrationStatus != 1){
					return false;
				}
			}
			return true;
		},
		isPeppolActive():boolean {
			if(this.company.dossiers){
				let c = this.company.dossiers.filter(d => d.id == this.ticket.dossierId);
				if(c[0] && ( c[0].peppolIds.length > 0 ||  c[0].peppolRegistrationStatus ==2 )){
					return true;
				}
			}
			return false;
		},
		peppolRegistrationStatus: {
			get():number {
				if(this.company.dossiers && this.company.dossiers.length > 0){
					let dossier = this.company.dossiers.find(d => d.id == this.ticket.dossierId) || this.company.dossiers[0];
					return dossier.peppolRegistrationStatus;
				}
				return 0;
			},
			set(value:number) {
				if(this.company.dossiers && this.company.dossiers.length > 0){
					let dossier = this.company.dossiers.find(d => d.id == this.ticket.dossierId) || this.company.dossiers[0];
					dossier.peppolRegistrationStatus = value;
				}
			}
		},
		peppolRegistrationStatusOptions():{ value: number, text: string }[] {
			return [
				{ value: 0, text: "Inactief" },
				{ value: 1, text: "In aanvraag" },
				{ value: 2, text: "Aanvraag voltooid" }
			];
		},
		supportWarning(): string {
			if (!this.company) {
				return "";
			}
			if (!this.company.servicePackExpirationDate) {
				if (this.company.isExpired) {
					return "warn";
				}
				return "";
			}
			if (this.company.isServicePackExpired) {
				return "warn";
			}
			if (this.company.activeUntil.getTime() != 0 && (this.company.activeUntil.getTime() < new Date().getTime())) {
				return "warn";
			}
			return "";
		},
		internalText(): string {
			if (this.ticket.visibleForClient) {
				return "Neen";
			}
			return "Ja";
		},
		assignedAdmins(): Admin[] {
			if (!this.ticket.assignedAdmins) {
				return [];
			}
			return this.ticket.assignedAdmins.map(a => a.admin).filter(a => a != null) as Admin[];
		},
		showDropOverlay(): boolean {
			return this.dragLevel > 0;
		},
		hasReadTicketMessage(): boolean {
			if (this.ticket.visibleForClient && this.ticket.unreadUsers.length > 0) {
				return false;
			}
			return true;
		},
		externalOrInternalMessageTooltip(): string {
			if (this.isPrivate) {
				return "Verstuur intern bericht";
			}
			return "Verstuur bericht naar klant";
		},
		textareaClass(): string {
			if (this.isPrivate) {
				return "intern";
			}
			return "";
		},
		amountOfPublicMessage(): number {
			let i = 0;
			this.ticket.messages.forEach(msg => {
				if (!msg.isInternal) {
					i++;
				}
			});
			return i;
		},
		getTimeSheduled(): string {
			if (this.ticket.isTicketSheduled()) {
				return this.ticket.getTimeSheduled();
			}
			return "Geen";
		},
		computeDate(): Date {
			return new Date(this.date.getFullYear(), this.date.getMonth(), this.date.getDate(),
				this.time.getHours(), this.time.getMinutes(), this.time.getSeconds());
		},
		openAdminList(): any[] {
			return this.ticket.openedAdmins.map(u => {
				u.name = u.name.split(" ")[0];
				return u;
			});
		},
		ticketLink() {
			return "/tickets";
		},
		allTicketsText(): string {
			return "Alle Tickets bekijken";
		},
		allTicketsURL(): string {
			if (this.ticket.company) {
				return "/tickets?companyId=" + this.ticket.company.id;
			}
			return "/tickets?tab=0";
		},
		isExpanded(): boolean {
			return this.textareaExpanded;
		},
		phones(): string {
			if (!this.company || !this.company.owner) {
				return "";
			}
			return this.company.owner.phone.split(";").map(t => {
				return "<a href='tel:" + t.replace(/\D/g, "") + "'>" + t + "</a>";
			}).join("&nbsp;");
		},
		ticketDescription():string{
			if (!this.ticket.messages[0]) return "";
			return specialLink(autoLink(this.ticket.messages[0].content));
		}
	},
	watch: {
		async "ticket.messages.length"() {
			await this.$nextTick();
			this.scrollBottom();
		},
		isPublic() {
			this.isPrivate = !this.isPublic;
			this.setFocusOnTextArea();
		}
	},
	methods: {
		async peppolActivated(){
			if(this.ticket.company){
				await CompanyDossierService.activatePeppol(this.ticket.company.id,this.ticket.dossierId);
				this.company = await CompanyService.getCompany(this.ticket.company.id);
			}
			this.showPeppolActivationModal=false;
		},
		async setPeppolRegistrationStatus(status: number){
			if(this.ticket.company && this.company.dossiers && this.company.dossiers.length > 0){
				let dossier = this.company.dossiers.find(d => d.id == this.ticket.dossierId) || this.company.dossiers[0];
				dossier.peppolRegistrationStatus = status;
				await CompanyDossierService.updateDossier(this.ticket.company.id, dossier);
			}
		},
		openTicket(){
			this.$router.push("/tickets");
			window.open("https://backend.winfakt.app/ticket/" + this.ticket.id,"_blank");
		},
		copyLink() {
			navigator.clipboard.writeText("https://backend.winfakt.app/ticket/" + this.ticket.id);
			this.$wf.notify("Link gekopieerd", "success", 3000, "check");
		},
		updateAttentions(value: TicketMessage) {
			this.attentions = value.attentions.map(a => new Admin(a.admin)) as Admin[];
			this.editAttentions = value.id;
			this.attentionModal = true;
		},
		async saveAttentions() {
			let i = this.ticket.messages.findIndex(a => a.id == this.editAttentions);
			this.ticket.messages[i].attentions = [];
			await TicketService.updateAttentions(this.ticket, this.editAttentions, this.attentions.map(a => a.id));
			this.attentions = [] as Admin[];
			this.editAttentions = 0;
		},
		triggerAction(value: string) {
			(this as any)[value]();
		},
		autoMessage() {
			this.addAutoMessage = true;
		},
		onTextAreaInput(event:any){
			this.content = event.target.value;
		},
		attachFile() {
			let input = this.$refs.fileInput as HTMLInputElement;
			input.click();
		},
		async setDepartment(departmentId: number) {
			await TicketService.setDepartment(this.ticket.id, departmentId);
			this.ticket.departmentId = departmentId;
		},
		async setStatus(statusId: number) {
			await TicketService.setStatus(this.ticket.id, statusId);
			let t = getTicketStatusName(statusId);
			await TicketService.sendResponse(this.ticket.id, {
				isInternal: true,
				isInterraction: true,
				content: "veranderde de status naar <b>" + t[1] + "</b>",
				attentions: [],
				attachements: [],
				notifyUser: false
			});
			this.ticket.statusId = statusId;
		},
		async sendResponse() {
			if (/^\s*$/.exec(this.content)) {
				return;
			}
			//If ticket is Intrnal and message is external warn user and change ticket visibility
			if (!this.ticket.visibleForClient && !this.isPrivate) {
				let confirm = await this.$wf.confirm(
					"Ben je zeker dat je dit ticket openbaar wil maken?"
						+ " Er zijn momenteel " + this.amountOfPublicMessage
						+ " externe berichten."
					, "Ja, maak openbaar", "Annuleren", "Opgelet! Dit is een intern Ticket!"
				);
				if (!confirm) {
					return;
				}
				await TicketService.makeTicketVisibleForClient(this.ticket.id);
			}

			await this.autoAttention();

			await TicketService.sendResponse(this.ticket.id, {
				isInternal: this.isPrivate,
				isInterraction: false,
				content: this.content,
				attentions: this.attentions.map(a => a.id),
				attachements: [],
				notifyUser: this.notifyUser
			});
			//this.notifyUser = false;
			this.content = "";
			this.attentions = [];
			this.isPublic = false;
			this.expand(false);
		},
		async autoAttention() {
			let a = await AdminsService.getAdmins();
			a.forEach((a) => {
				if (this.content.toLowerCase().indexOf("@" + a.firstName.toLowerCase()) > -1) {
					this.attentions.push(new Admin(a));
				}
				if (this.content.toLowerCase().indexOf("@sales") > -1) {
					if ([49, 55, 101, 118].includes(a.id)) {
						this.attentions.push(new Admin(a));
					}
				}
				if (this.content.toLowerCase().indexOf("@kd") > -1) {
					if ([45, 57].includes(a.id)) {
						console.log(a);
						this.attentions.push(new Admin(a));
					}
				}
			});
		},
		async setAssignedAdmins(admins: Admin[]) {
			await TicketService.setAssignedAdmins(this.ticket.id, admins.map(a => a.id));
		},
		onDragStart() {
			this.dragLevel++;
		},
		onDragEnd() {
			this.dragLevel--;
		},
		async onFileInput(event: Event) {
			let input = event.target as HTMLInputElement;
			if ((input.files || []).length == 0) {
				return;
			}
			let files = [] as File[];
			for (let file of (input.files || [])) {
				files.push(file);
			}
			input.value = "";
			await this.sendFiles(files);
		},
		async onFileDrop(event: DragEvent) {
			this.dragLevel = 0;
			if (!event.dataTransfer) {
				return;
			}
			if (event.dataTransfer.files.length == 0) {
				return;
			}
			let files = [] as File[];
			for (let file of event.dataTransfer.files) {
				files.push(file);
			}
			await this.sendFiles(files);
		},
		async sendFiles(files: File[]) {
			try{
				await TicketService.sendResponse(this.ticket.id, {
					isInternal: this.isPrivate,
					isInterraction: false,
					content: "",
					attachements: files,
					notifyUser: false
				});
			}catch(err){
				throw err;
			}finally{
				this.onPasteToSendFiles = [];
			}
		},
		scrollBottom() {
			if (!this.$el) return;
			var container = this.$el.querySelector(".messages");
			if (container)
				container.scrollTop = 0;//(container.scrollHeight);
		},

		async onTextInputCtrlKeyDown(event: KeyboardEvent) {
			if (event.shiftKey) return;
			if (event.key == "z") {
				if (this.content != "") return;
				try {
					await TicketService.deleteLastMessage(this.ticket.id);
				} catch (e) {
					if (document.activeElement && (document.activeElement as HTMLElement).blur) {
						(document.activeElement as HTMLElement).blur();
					}
				}
			}
		},
		async upKeyPressed() {
			return;
		},
		async onUpdatingChange(message: TicketMessage, isUpdating: boolean) {
			if (isUpdating) {
				this.updatingMessageId = message.id;
			} else {
				this.updatingMessageId = 0;
			}
		},
		async setTicketPriority(priority: number) {
			let originalPrio = priority;
			this.ticket.priority = priority;
			try {
				let result = await TicketService.setTicketPriority(this.ticket.id, priority);
				this.ticket.priority = result.priority;
			} catch (err) {
				this.ticket.priority = originalPrio;
			}
		},
		showModules() {
			this.showModuleModal = true;
		},
		toggleTicketIsVisibleForClient() {
			TicketService.setVisibleForClient(this.ticket.id, !this.ticket.visibleForClient);
		},
		editTimeSheduled() {
			this.showTimeSheduledModal = true;
		},
		removeShedule() {
			this.saveTimeShedule(new Date(0));
			this.showTimeSheduledModal = false;
		},
		saveShedule() {
			this.saveTimeShedule(this.computeDate);
			this.showTimeSheduledModal = false;
		},
		async saveTimeShedule(date: Date) {
			await TicketService.sheduleTicket(this.ticket.id, date);
			this.ticket.timeSheduled = date;
			this.showTimeSheduledModal = false;
		},
		setFocusOnTextArea() {
			let textArea = this.$refs.textarea as HTMLInputElement;
			textArea.focus();
		},
		async autoExpand(delay: number = 0) {
			if (!this.textareaExpanded) {
				let txt = this.$refs["textarea"] as HTMLTextAreaElement;
				setTimeout(function () {
					let h = txt.scrollHeight - 10;
					h = h > 350 ? 350 : h;
					txt.setAttribute("style", "flexGrow:1; height:" + ((h)) + "px;");
				}, delay);
			}
		},
		expand(textareaExpanded: boolean) {
			this.textareaExpanded = textareaExpanded;
			let txt = this.$refs["textarea"];
			if (txt && txt instanceof Element) {
				if (this.textareaExpanded) {
					txt.setAttribute("style", "flexGrow:1; height:350px;");
				} else {
					txt.setAttribute("style", "flexGrow:1; height:20px;");
				}
			}
			let msgs = document.getElementsByClassName("messages");
			if (msgs && msgs[0]) {
				msgs[0].scrollTop = 0;//msgs[0].scrollHeight;
			}
			this.setFocusOnTextArea();
		},
		async addTemplateText(item: TicketReplyTemplate) {
			let content = await TicketService.computeTemplate(this.ticket.id, item.content);
			this.content += content;
			this.isPublic = item.external;
			this.expand(!this.textareaExpanded);
			this.addAutoMessage = false;
			if (this.ticket.client) {
				CompanyService.createCrm(this.ticket.client.companyId, new CRM({eventId: 1}));
			}
		},
		onPaste(event: ClipboardEvent) {
			console.log("On paste");
			if (!event.clipboardData) return;
			if (event.clipboardData.files.length == 0) return;
			this.onPasteToSendFiles = [...event.clipboardData.files];
		},
		onKeyDown(e: KeyboardEvent) {
			if (e.keyCode == 27) {
				if (this.content == "") {
					this.$router.push("/tickets");
				}
			}
			return;
		},
		onTextAreaPaste(event:ClipboardEvent){
			if (!event.clipboardData) return;
			if (event.clipboardData.files.length > 0) {
				this.onPaste(event);
				return;
			};
			this.autoExpand(100);
		},
		scrollToMessage(messageId:number){
			if (!this.$refs.messagesContainer) return;
			let messageNodes = this.$refs.messages as Vue[];
			console.log(messageNodes.length);
			for (let node of messageNodes){
				if (node.$vnode.key != messageId){
					continue;
				}
				(this.$refs.messagesContainer as any).scrollTo(node.$el);
				break;
			}
		},
		onReplyToClicked(username:string){
			if (this.content.indexOf(`@${username} `) != -1) return;
			this.content = "@" + username + " " + this.content;
		},
		async saveCompanyNotes(){
			if (!this.ticket.company) return;
			await CompanyService.updateVars(this.ticket.company.id, this.companyVars);
			this.$wf.notify("Notities opgeslagen", "success", 3000, "check");
		}
	},
	async mounted() {
		if (AdminsService.admins.length == 0) {
			await AdminsService.getAdmins();
		}
		this.ticket = await TicketService.getTicket(parseInt(this.$route.params.id));
		setTitle(this.ticket.subject);
		this.ready = true;
		if (!this.ticket.isTicketRead()) {
			if (TicketService.storedFilters && TicketService.storedFilters.read === false){
				TicketService.storedRecords--;
			}
			await TicketService.markTicketAsRead(this.ticket.id);
		}
		if (this.ticket.company) {
			this.company = await CompanyService.getCompany(this.ticket.company.id);
			this.companyVars = await CompanyService.getVars(this.company);
		}
		this.ticket.registerSocketEvents();
		if (this.ticket.isTicketSheduled()) {
			this.date = this.ticket.timeSheduled;
			this.time = this.ticket.timeSheduled;
		}
		TicketService.fetchOpenedAdmins(this.ticket);
		this.ticket.join();
		this.setFocusOnTextArea();
		document.addEventListener("paste", this.onPaste);
		document.addEventListener("keydown", this.onKeyDown);
		let toOpenMessageId = parseInt(this.$route.query.messageId as string || "0");
		if (Number.isNaN(toOpenMessageId)){
			toOpenMessageId = 0;
		}
		this.scrollToMessage(toOpenMessageId);
	},
	async destroyed() {
		this.ticket.deregisterSocketEvents();
		resetTitle();
		this.ticket.leave();
		document.removeEventListener("paste", this.onPaste);
		document.removeEventListener("keydown", this.onKeyDown);
	},
	components: {
		AppSelectDepartment,
		AppTicketMessage,
		AppAdminSelect,
		AppTicketStatusSelect,
		AppTicketSelectPriority,
		AppAdminCheckboxesSelect,
		AppTicketPinButton,
		AppTicketBookmarkButton,
		AppTicketMessageActions,
		AppTicketReplyTemplateButton,
		AppTicketCrm,
		AppTicketNextAndPreviousButtons,
		AppTicketPasteAttachmentPreview,
		AppLoginAsUserButton,
		AppPeppolActivationModal,
		AppTicketEditSubjectModal
	}
});
